$(function(){
	if (isPALMode()) {
		return;
	}

// REMOVE: after php adjustments
  if (window.location.href.indexOf('EditRecord') > -1){
    $('body').addClass('details');
  }

  // $('.section-light:eq(1)').addClass('section-dark');
  $('table.RecordData tr td[tablename]').each(function(){
    if ($(this).find(':input').length === 0){
      $(this).addClass('readonly');
    }
  });

  $('.BulkTasks a').addClass('BulkTaskLink');

  // $('[id^=divShowImages]').addClass('ImageSection');

// REMOVE: end



  /* NAVIGATION */
  var $nav_item = $('#nav > li > a[href="' + location.href.replace(location.origin, '') + '"]');
  if ($nav_item.length === 0){
    $nav_item = $('#nav > li > a[href*="' + location.search.substr(0,location.search.indexOf('&')) + '"]');
  }
  $nav_item.parent().addClass('active');
  /* NAVIGATION */


    /* notification area */
    $('body').append('<div id="save_controls" class="notification"><div class="notification-error"></div><span>You have unsaved changes</span> </div>');

    $('#save_controls').append($('#SaveAllTop')).append($('#ResetAllTop'));

    // handle changes for inputs and selects
    $('body.details #maindiv').on('change keyup', ':input,select', function(e){
    	//Disable save and cancel button for input fields under genie training set template
    	if ($(e.target).closest("#divShowTemplateGenieTrainingSet")[0]) {
            return;
        }
    	var self = this;
  
    	// Get the element with a valid id (canned comments have three levels: select, br, textarea)
    	while(undefined === self.id || !self.id)
    	{
    		self = $(self).next()[0];
			if (self === undefined) {
				// Not all elements have IDs, if we cant find an ID assume original element.
				self = this;
				break;
			}

    		// Come out if we have traversed until last element on the form
    		if($(self) === $(self).closest('tbody').find(":input").last()) { 
    			break;
    		}
    	}
 
        setModifiedState($(self));
    });
    function setModifiedState($element)
    {
        if (undefined !== $element.attr('oldvalue') && $element.val() !== $element.attr('oldvalue')) {
            $element.addClass('Modified');
		}
        else {
            $element.removeClass('Modified');
            delete modifiedElems[$element.id];
		}
        setSaveControls($element);		// slide the save controls in or out based on the presence of Modified data on the page
    }
    /* Map of elements that are pending save; key is the element id, value is the $element. */
    var modifiedElems = {};

	// Cancel
  $('#ResetAllTop').on('click', function(){
		ResetAll();
		resetSaveControls();
		archiveGeneral.resetArchiveButton();
  });

  $('#SaveAllTop').on('click', function(){
	// Clear previous errors and disable buttons during the save
    $('#save_controls .notification-error').empty();
    $('#save_controls input').attr('disabled', 'disabled').addClass('disabled');
  });

  /** @param eventData		Contains data newly saved to the DB (if any). */
  $('body').on('ProcessSaveResponse', function(event, eventData)
  {
    var savedData = eventData && eventData.Cells;
    if (!savedData) return;

	for (var id in modifiedElems)
	{
        var $elem = modifiedElems[id];
		//Reset Save Controls if the element has no modified class (data already saved)
		if(!$elem.hasClass('modified')) {
			delete modifiedElems[$elem.id];
			setSaveControls($elem);   
			continue;
		}
        var fieldName = $elem.attr('name');
        var savedValue = savedData[fieldName];
        if (!savedValue) continue;

		var $asObj = $.parseHTML(savedValue.Contents);	// Create a JQuery Object from the String .Contents property, to facilitate retrieving its "value" attribute.
		var newContent;
		// Get the element (from DS Response) which has a valid id (canned comments have three levels: select, br, textarea)
		$.each($asObj, function (index){
			if($asObj[index].id) { 
				newContent = $asObj[index].value; 
				return;
			}
		});
		if (newContent == $elem.val()){	// If the newly saved data (returned from the DB) is the same as our UI field, the data was saved!
            $elem.attr('oldvalue', newContent);
            setModifiedState($elem);   // NOTE: calls resetSaveControls() if no Modified elems remain.
        }
    }
  });

  $('body').on('ProcessSaveResponseError', function(event, detail){
    setSaveControls($(this));
    if (typeof detail.elem != 'undefined'){
      $(detail.elem).find(':first').addClass('FieldError');
      $('#save_controls .notification-error').append('<span>' + detail.data + '</span>');
    }
  });

	function setSaveControls($this)
	{
    if (CheckDataUnsaved()){
		$('#save_controls').addClass('in');
		$('#save_controls input').removeAttr('disabled').removeClass('disabled');
      var $tab = $this.closest('.tab-content'),
          $SubSection = $this.closest('.SubSection');
      if ($tab.length > 0){
		//Adding modified class to the active tab for enabling sprite
        $('.tabs li[data-id="' + $tab.data('id') + '"][data-table=' + $tab.data('table') + ']').addClass('modified');	// FieldModified
        // $tab.parent().$tab.data('id')
      }
      if ($SubSection.length > 0){
        if ($SubSection.prev().is('h3')){
          $SubSection.prev().addClass('modified');	// FieldModified
        }
      }
      modifiedElems[$this[0].id] = $this;
    } else {
      resetSaveControls();
    }
   }

  function resetSaveControls(){
	// reenable the buttons, clear all errors
	$('#save_controls input').removeAttr('disabled').removeClass('disabled');
	$('#save_controls .notification-error').empty();
	if (!CheckDataUnsaved()){
		// Hide the controls, clear all indicators
		$('#save_controls').removeClass('in');
		$('h3').removeClass('modified');	// FieldModified
		$('.tabs li').removeClass('modified');	// FieldModified
	}
  }

  /* notification */


  /* LIST */

  $('#ButtonAddNew').prepend('<i class="icon icon-plus"></i>');

	// For all eSlideTray.php links, add target frame on click so that they open in same window
	$('body').on('click', '.viewerlaunch', function(event){
		$(this).attr('target', SystemParms.WebViewerTargetFrameName || 'WebViewer');
	});
  
  $(document).on('RefreshPaginator', function(event){
    thePaginator.paginator(true);
  });

	$('body').on('click', '.toggleSummaryRow', function(event){
		event.preventDefault();
		var $this = $(this);
		$this.toggleClass('open');
		$this.closest('.DataRow').next().toggleClass('open');
	});

  // tooltips
  function simpleTooltips(){
	$('table.ListTable tr.DataRow > td:not(:empty)').each(function() {
		var $this = $(this);
		var title = $this.attr('title');
		if (((title === undefined) || (title === false)) && ($this.text() != '')) {
			// If title not already defined, use field's text
			$this.attr('title', $.trim($this.text()));
		}
	});
  }
	
 /* end LIST */


	/* DETAILS PAGE */

	// expanding logic
	$('body.details').on('click', 'h3', function(event)
	{
		if ($(event.target).is('.BulkLink'))
			return;

		var $h3 = $(this);

		if ($h3.parent().hasClass('sticky-header')){
			$h3 = $h3.parent().data('original-elem');
		}

		var $div = GetExpansionIndicator($h3);
		var isOpen = $div.hasClass('open');
		var doExpand = !isOpen;	// toggle the state
		var target = $h3.find('svg[data-toggle]').attr('data-toggle');
		var $target = $h3.parent().find('[id=' + target + ']');
		// var isClone = $h3.parent().hasClass('sticky-header');

		if ($target.find('>.tabs').length > 0){
			$target = $target.find('>.tab-holder>.tab-content:eq(0),>.tab-holder>.tab-content>.SubSectionLeft,>.tab-holder>.tab-content>.SubSectionRight,>.tab-holder>.tab-content>.SubSection>.SubSectionLeft,>.tab-holder>.tab-content>.SubSection>.SubSectionRight');
		} else if ($target.find('>.tab-holder').length > 0){ // TOP LEVEL
			$target = $target.find('>.tab-holder>.tab-content>.SubSectionLeft,>.tab-holder>.tab-content>.SubSectionRight');
		}

		if (doExpand)
		{
			$target.css('display', '');
		}
		else
		{
			$target.css('display', 'none');
		}

		/**
		if (doExpand)
		{
			// remove inline styling on active tabs (this messes with our css styling)
			$target.each(function()
			{
				$(this).closest('.tab-content.active').css('display', '');
			});
		}
		***/
		// update the navfloat offset when we have toggle any h3 block
		leica.pi.esm.floatingHeaders.detailsHeader.UpdateNavFloatOffset();
		
		$div.toggleClass('open');
		$(window).trigger('scroll');
	});

	function GetExpansionIndicator($h3)
	{
		// Chevron's parent div holds 'open' class
		var $img = $h3.find('svg[data-toggle]');
		return $img.parent();
	}

  function addModifiedNotification(){
    $('h3 .details-header').each(function(){
      var $this = $(this);
      if (!$this.prev().is('.modified-notification')){
        $this.before('<span class="modified-notification">*</span>');
      }
    });
  }

  function changeLayoutBasedOnImages(){
    $('.SubSectionLeft').each(function(){
      var $images = $(this).find('> [id^=divShowImages]');
      if ($images.length > 0){
        if ($images.find('a.BulkLink:contains(Delete)').length > 0){
          $images.next().addClass('has-images');
        }
      }
    });
  }

  
  // Call for the floating headers in details section
  leica.pi.esm.floatingHeaders.detailsHeader.run();
  
/* Vince??? */
/*
  var $SubSectionActions = $('<div class="SubSectionRightActions"></div>');
  $SubSectionActions.append($('.details .SubSectionRight > h3'));
  $SubSectionActions.append($('.details .SubSectionRight > input'));
  // $SubSectionActions.append('<input type="button" value="Add Something">');
  $('.details .SubSectionRight').prepend($SubSectionActions);
  var $SubSectionItems = $('<div class="SubSectionItems"></div>');
  $SubSectionItems.append($('.details .SubSectionRight > div.SubSection'));
  $('.details .SubSectionRight').append($SubSectionItems);
*/


  function tabs(){
    $('.tabs:not(.tabs-loaded)').each(function(){
      var $tabs = $(this),
          $tabHolder = $tabs.parent().find('>div:last').addClass('tab-holder');

      $tabs.addClass('tabs-loaded');
      $tabHolder.on('click', '.tab-open', function(event){
        event.preventDefault();
        event.stopPropagation();
        var $this = $(this);
        $tabs.addTab($this.closest('[tablename]').attr('tablename'), $this.closest('tr').attr('ids'));
      });

      $tabs.on('click', 'li, li .close', function(event){
        if ($(this).hasClass('close')){
          event.preventDefault();
          event.stopPropagation();
          $tabs.removeTab($(this).parent().index());
        } else {
          $tabs.activateTab($(this).index());
        }
      });

      $tabs.find('.tab-navigate').on('click', function(event){
        event.preventDefault();
        var dir = $(this).index();
        if (dir == 0){
          $tabs.find('ul').get(0).scrollLeft -= ($tabs.width()/3);
        } else {
          $tabs.find('ul').get(0).scrollLeft += ($tabs.width()/3);
        }
      });

      if ($tabHolder.find('.tab-content.active').length === 0){
        $tabHolder.find('.tab-content:first').addClass('active');
      }

      $.extend($tabs, {
		addTab: function(table, id){
			if ($tabs.find('li[data-id=' + id + '][data-table=' + table + ']').length > 0)
	  		{
				$tabs.find('li[data-id=' + id + '][data-table=' + table + ']').trigger('click');
			}
			else
	  		{
				var $parentTab = $(this).closest('.active');
				var parentId = $parentTab.attr('data-id');

            	$.getJSON('/GetData.php', { Content: 'Details', Command: 'Add', TableName: table, Id: id, ParentId: parentId }, function(data)
				{
					if (data && data.Tabs && (data.Tabs.length > 0))
					{
						for (var i = 0; i < data.Tabs.length; i++)
						{
							if ($tabs.find('li[data-id=' + id + '][data-table=' + table + ']').length == 0)
							{
								// if ($tabs.find('li:contains(' + data.Tabs[i].Header + ')').length == 0)
								if (data.SectionHeader)
									data.Tabs[i].SectionHeader = data.SectionHeader;
								$tabs.createTab(table, id, data.Tabs[i]);
							}
						}
						// temp_tabs();
						setTimeout(function()
						{
							pageInit();
						}, 2000);
						archiveGeneral.toggleDetailsDeleteButton();
						// don't want to wait 2 seconds for this one
						changeLayoutBasedOnImages();
					}
				});
			}
		},

		removeTab: function(sectionIndex){
			var $tab = $tabs.find('li').eq(sectionIndex);
			var	$tabContent = $tabHolder.find('div.tab-content').eq(sectionIndex);

			// FieldModified
			if ($tab.hasClass('modified')){
				if (!confirm("Data on this tab has been modified. If you proceed without saving, these changes MAY BE LOST.\n\nIf you wish to save the changes please press CANCEL.")){
					return;
				}
			} else if ($tabContent.find('.tabs .modified').length > 0){
				if (!confirm("Data on this tab OR one of the tabs below has been modified. If you proceed without saving, these changes MAY BE LOST.\n\nIf you wish to save the changes please press CANCEL.")){
					return;
				}
			}

			var TableName = $tab.attr('data-table');
			$allTabs = $tabHolder.find('div.tab-content');
			for (i = 0; i < $allTabs.length; i++)
			{
				// Find the tab in the same section that is closest to the one being removed
				if ($allTabs.eq(i).attr('data-table') == TableName)
				{
					//var id = $allTabs.eq(i).attr('data-id');
					if (sectionIndex == $allTabs.eq(i).index())
					{
						allTabsRemoveIndex = i;
						break;
					}
				}
			}
			if ($tab.hasClass('active')){
				$tabs.activateTab(sectionIndex - 1);
			}

			$.getJSON('/GetData.php', { Content: 'Details', Command: 'Remove', TableName: $tab.data('table'), Id: $tab.data('id') }, function(data){
				// success?
				archiveGeneral.toggleDetailsDeleteButton();
			});

			$tabs.find('li').eq(sectionIndex).remove();
			$tabHolder.find('div.tab-content').eq(allTabsRemoveIndex).remove();
			resetSaveControls();

			// Remvoe all nodes that were deleted from the DOM
			NodeCheck();
		},

		createTab: function(table, id, data)
		{
			var $li = $('<li data-id="' + id + '" data-table="' + table + '">' + data.Header + ' <a href="" class="close">x</a></li>');
			if (data.SectionHeader)
			{
				$li.data('section-header', $(data.SectionHeader).find('.details-header').html());
				$li.data('navigation-header', $(data.SectionHeader).find('.navigation-header').html());
			}
			$tabs.find('ul').append($li);
			var $tabContent = $('<div data-id="' + id + '" data-table="' + table + '" class="tab-content">' + data.Data + '</div>');
			$tabHolder.append($tabContent);

			for (var i = 0; i < data.NewNodes.length; i++)
			{
				var nodeName = data.NewNodes[i];
				new cDetails(nodeName, nodeName + 'Table');
			}

			for (var i = 0; i < data.NewLists.length; i++)
			{
				var cListName = data.NewLists[i];
				try {
					var Node = FindNode(cListName);
					Node.OnLoad();
				} catch (e){
					console.log(e);
				}
			}

			$tabs.activateTab($tabs.find('li').length - 1);
		},

        activateTab: function(index)
		{
          if ($tabHolder.find('>div').length > index){
            var $_active = $tabs.find('li').eq(index),
                $_tabContent = $tabHolder.find('>div').eq(index),
                $h3 = $tabs.closest('.SubSection').prev(),
                details = $_active.data('section-header'),
                Navigation = $_active.data('navigation-header');
            if (!details){
              details = '';
            }
            if (!Navigation){
              Navigation = '';
            }
            $tabs.find('li').removeClass('active');
            $_active.addClass('active');
            $h3.find('.details-header').html(details);
            $h3.find('.navigation-header').html(Navigation);
            $tabHolder.find('>div').removeClass('active');
            $_tabContent.addClass('active');

			var $node = GetExpansionIndicator($h3);
			if ((index == 0) && ($node.hasClass('open') == false))
			{
				// If user chooses the slide list, ensure div is visible
				$h3.trigger('click');
            }

            $('body').trigger('tabChanged', { index: index, tab: $_active, tabContent: $_tabContent });
          }
        }

      });

    });
  }

  function pageInit(){
    tabs();
    changeLayoutBasedOnImages();
    thePaginator.paginator();
    thePaginator.recordCounter();
    simpleTooltips();
    addModifiedNotification();
  }
  pageInit();

});

//
// Functions
//

// Return the div that the table list will shift during a pan
function getDivToMove($obj, direction) {
	var $listShiftPan;
	if (direction == 'up')
		$listShiftPan = $obj.parents('.ListTableWrapper');
	else
		$listShiftPan = $obj.find('.ListTableWrapper');
	if ($listShiftPan.length > 0)
		return $listShiftPan;
	return null;
}

